
import {IUserLogEntryBuilder} from './i.user.log.entry.builder';
import {IUserLogEntryOptions} from './i.user.log.entry.options';

/**
 *
 * @class MessageBuilder
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2021
 *
 */
export class MessageBuilder implements IUserLogEntryBuilder {

  /** convert raw MongoDB user log entry into data that can construct a tree node */
  build(data: any, args: IUserLogEntryOptions): any {

    const u: string = data._id.match(/^msg-(.*)/i)[1];

    return {
      id:          data._id,
      seq:         parseInt(data.seq),
      name:        `${data.tx}`,
      hasChildren: args.hasChildren,
      isExpanded:  args.isExpanded,
      type:        'message',
      children:    args.children,
      parent:      args.parent,
      kids:        [],
      tags:        [],
      label:       data.lb,
      pkey:        data.pa,
      text:        data.tx,
      u
    };

  }
}
